import { useContext } from "react";

import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextArea,
  InputTextMaster,
} from "App/Component/ui";
import { FormContext } from "../../context/FormContext";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import DatePicker from "react-datepicker";
import moment from "moment";
import { isNull } from "App/utils/helpers";
import { status_kebutuhan, STATUS_TRANSAKSI_PENGAJUAN } from "../../helpers";
export default function FormReq() {
  const { formData, setFormData } = useContext(FormContext);

  const unit = useSelectOption(
    true,
    "/wmsmaster/unit/read_gudang_farmasi",
    TYPE_INSTANCE4
  );

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  // const changeSelectWithLocalStorage = (e, name_id, name_label) => {
  //   setFormData({
  //     ...formData,
  //     [name_id]: e?.value,
  //     [name_label]: e?.label,
  //   });
  // };

  // useEffect(() => {
  //   setFormData({
  //     ...formData,
  //     date: moment(new Date()).local().toDate(),
  //   });
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <form action="">
      <Grid container spacing={1}>
        <Grid item sm={6}>
          <Grid container spacing={1}>
            <Grid item sm={4}>
              <InputTextMaster
                name="id"
                label="ID / ID REQUEST"
                id="id"
                placeholder="0/0"
                disabled={true}
                value={formData.idreq}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="nama"
                label="NAMA PERMINTAAN"
                id="nama"
                placeholder="Nama Permintaan"
                disabled={formData.status_verifikasi >= STATUS_TRANSAKSI_PENGAJUAN ? true : false}
                value={formData.nama}
                onChange={handleChange("nama")}
              />
            </Grid>
            <Grid item sm={4}>
              <div
                style={{
                  marginTop: "0.5rem",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <label htmlFor="date" className="form-control-label">
                  TANGGAL
                </label>

                <div
                  onClick={() =>
                    setFormData({
                      ...formData,
                      date: moment(new Date()).local().toDate(),
                    })
                  }
                  style={{
                    fontSize: "10px",
                    color: "#3399ff",
                    cursor: "pointer",
                  }}
                >
                  Today
                </div>
              </div>
              <DatePicker
                id="date"
                autoComplete="off"
                className="form-control text"
                dateFormat="dd/MM/yyyy HH:mm"
                timeFormat="HH:mm"
                showTimeSelect
                timeIntervals={5}
                locale="id-ID"
                selected={moment(formData.date).toDate()}
                disabled={formData.status_verifikasi >= STATUS_TRANSAKSI_PENGAJUAN ? true : false}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    date: e,
                  });
                }}
                placeholderText="Tanggal"
              />
              {/* <InputTextMaster
                name='date'
                label='TANGGAL'
                id='date'
                disabled={formData.isProcess}
                value={formData.date}
                onChange={handleChange("date")}
                placeholder='Tanggal'
                type={"datetime-local"}
              /> */}
            </Grid>
            <Grid item sm={4}>
              <InputOptionMaster
                name="id_unit"
                label="UNIT"
                id="id_unit"
                disabled={formData.status_verifikasi >= STATUS_TRANSAKSI_PENGAJUAN ? true : false}
                withSearch={true}
                value={formData.unit_id}
                labelValue={formData.unit}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      id_unit: null,
                      unit: "Pilih Unit",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      unit_id: e.value,
                      unit: e.label,
                    });
                  }
                }}
                data={unit}
                error={true}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="user"
                label="USERNAME REQUEST"
                id="user"
                disabled={formData.status_verifikasi >= STATUS_TRANSAKSI_PENGAJUAN ? true : false}
                value={formData?.user_request}
                placeholder="Username Request"
                onChange={handleChange("user_request")}
              />
            </Grid>
            <Grid item sm={4}>
            <InputOptionMaster
                name="status_kebutuhan_id"
                label="TINGKAT STATUS KEBUTUHAN"
                id="status_kebutuhan_id"
                withSearch={true}
                data={status_kebutuhan}
                value={formData?.status_kebutuhan}
                disabled={formData.status_verifikasi >= STATUS_TRANSAKSI_PENGAJUAN ? true : false}
                labelValue={formData?.status_kebutuhan_nama}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      status_kebutuhan: null,
                      status_kebutuhan_nama: "Pilih Status",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      status_kebutuhan: e.value,
                      status_kebutuhan_nama: e.label,
                    });
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item sm={3}>
          <InputTextArea
            name="remark"
            disabled={formData.status_verifikasi >= STATUS_TRANSAKSI_PENGAJUAN ? true : false}
            label="CATATAN TRANSAKSI"
            id="remark"
            placeholder="Catatan"
            rows={6}
            value={formData.remark}
            onChange={handleChange("remark")}
          />
        </Grid>
        <Grid item sm={3}>
          <InputTextArea
            name="remark"
            label="CATATAN VERIFIKASI"
            id="remark"
            placeholder="Catatan"
            rows={6}
            value={formData.remak_verifikasi}
            disabled={true}
            readOnly={true}
          />
        </Grid>
      </Grid>
    </form>
  );
}
